import React, { useState, useEffect } from "react"; // Importamos useEffect
import Autocomplete from "./Autocomplete";

// Configuración de la nueva API
const API_URL = "https://pjb.edu.ar/api/desbloqueos_v2/genericos.php";
const TOKEN = "a3f19c8e2b7d4f6a1c0e5b9d7a2f3c8e6d1b4a7f9e2c5d0b8a6c3e1f7d4b2aa9";

export default function Generico() {
  const [sn, setSn] = useState("");
  const [loading, setLoading] = useState(false);
  const [archivos, setArchivos] = useState([]); // Lista de archivos encontrados
  const [error, setError] = useState("");

  const buscar = async () => {
    setError("");
    setArchivos([]);

    const snLimpio = sn.trim();

    if (!snLimpio) {
      setError("Debe ingresar un número de serie válido.");
      return;
    }

    // Validación de SN bloqueados
    if (snLimpio === "81cd781af38f61c49a42" || snLimpio === "fe065ab52323227adeb8") {
      setError("El número ingresado no requiere este procedimiento.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}?sn=${snLimpio}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (data.success) {
        if (data.results.length === 0) {
          setError("No se encontraron paquetes de desbloqueo para este S/N.");
        } else {
          setArchivos(data.results);
        }
      } else {
        setError(data.message || "Error en la consulta al servidor.");
      }
    } catch (err) {
      console.error(err);
      setError("Error conectando con el servidor de archivos.");
    } finally {
      setLoading(false);
    }
  };

  // Función para descargar y renombrar el archivo
  const descargarArchivo = async (nombreOriginal) => {
    try {
      const res = await fetch(`${API_URL}?download=${encodeURIComponent(nombreOriginal)}`, {
        headers: { 'Authorization': `Bearer ${TOKEN}` }
      });

      if (!res.ok) throw new Error("Error en la descarga");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      
      a.href = url;
      // Renombramos aquí: "desbloqueo_" + S/N
      a.download = `desbloqueo_${sn.trim()}.zip`; 
      
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("No se pudo descargar el archivo.");
    }
  };

    useEffect(() => {
      const snLimpio = sn.trim();

      // Solo si tiene 6 o más caracteres
      if (snLimpio.length >= 6) {
        const timer = setTimeout(() => {
          buscar();
        }, 500); // Espera 500ms después de que el usuario deja de escribir

        return () => clearTimeout(timer); // Limpia el timer si el usuario sigue escribiendo
      } else {
        setArchivos([]);
        setError("");
      }
    }, [sn]);

  return (
    <div className="container ontOption">
      <div className="card p-4 shadow-sm">
        {/* Mensaje institucional */}
        <div className="alert alert-secondary" style={{ fontSize: "0.9rem", lineHeight: "1.4" }}>
          <strong>Información importante:</strong> Este módulo está destinado exclusivamente a personal técnico autorizado.
        </div>

        {/* Input con Autocompletar */}
        <Autocomplete onSelect={(v) => setSn(v)} />

        {/* Botón buscar */}
        <button className="btn btn-primary mt-3" onClick={buscar} disabled={loading}>
          {loading ? "Buscando..." : "Buscar Archivo"}
        </button>

        {/* Mensajes de Error */}
        {error && <div className="alert alert-warning mt-3">{error}</div>}

        {/* Resultados */}
        {archivos.length > 0 && (
          <div className="mt-4">
            <h5>Paquetes Encontrados</h5>
            <div className="list-group">
              {archivos.map((archivo, index) => (
                <div key={index} className="list-group-item d-flex justify-content-between align-items-center bg-light">
                  <div>
                    <i className="bi bi-file-earmark-zip text-primary me-2"></i>
                    <strong>{archivo.name}</strong>
                    <div className="text-muted small">Tamaño: {archivo.size}</div>
                  </div>
                  <button 
                    className="btn btn-success btn-sm" 
                    onClick={() => descargarArchivo(archivo.name)}
                  >
                    Descargar ZIP
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}